<style scoped>
    ion-label.wrapped {
        text-overflow: unset !important;
        white-space: normal !important;
        overflow: auto !important;
    }

    .check-time {
        font-size: 0.75em;
        padding-bottom: 0.3em;
        opacity: 0.5;
    }

    ion-input {
        text-align: end;
    }

    ion-item {
        --highlight-height: 0;
    }

    .baseline-fixer {
        display: flex;
        align-items: center;
        width: 100%;
    }

    ion-input {
        align-self: baseline;
    }

    ion-label.unit {
        margin-left: 0;
    }
</style>

<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-back-button defaultHref="/tabs"></ion-back-button>
        </ion-buttons>
        <ion-title>Settings</ion-title>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-list-header>Chart Options</ion-list-header>
    <!--<ion-item> Not implemented yet
        <ion-label>X Axis</ion-label>
        <ion-select [ngModel]="settings.xAxisType()" (ngModelChange)="settings.xAxisType.set($event)">
            <ion-select-option value="relative">Seconds</ion-select-option>
            <ion-select-option value="time">Time</ion-select-option>
            <ion-select-option value="date">Date</ion-select-option>
        </ion-select>
    </ion-item>-->
    <ion-item>
        <ion-select
            labelPlacement="start"
            justify="space-between"
            [ngModel]="settings.chartDivPolicy()"
            (ngModelChange)="settings.chartDivPolicy.set($event)"
        >
            <div slot="label" class="wrapped" style="text-align: left; padding-right: 16px">Signal Grouping</div>
            <ion-select-option value="single">Single Chart</ion-select-option>
            <ion-select-option value="perSlot">Group by Data Type</ion-select-option>
            <ion-select-option value="perSignal">Chart per Signal</ion-select-option>
        </ion-select>
    </ion-item>
    <ion-item>
        <ion-input labelPlacement="start" type="number" text-align="end" [(ngModel)]="preferredFineWidth" [min]="1">
            <div slot="label" class="wrapped" style="text-align: left; padding-right: 16px">Default Chart Span</div>
            <span slot="end" class="unit" style="margin-left: 0.5em; opacity: 0.5">s</span>
        </ion-input>
    </ion-item>
    <ion-item>
        <ion-input labelPlacement="start" type="number" text-align="end" [(ngModel)]="preferredCoarseWidth" [min]="1">
            <div slot="label" class="wrapped" style="text-align: left; padding-right: 16px">Default Viewfinder Span</div>
            <span slot="end" class="unit" style="margin-left: 0.5em; opacity: 0.5">s</span>
        </ion-input>
    </ion-item>
    <ion-item>
        <ion-toggle justify="space-between" [(ngModel)]="alwaysShowCoarse">
            <div class="wrapped">Always Show Coarse Adjuster</div>
        </ion-toggle>
    </ion-item>
    <ion-item>
        <ion-select
            labelPlacement="start"
            justify="space-between"
            [ngModel]="settings.themePolicy()"
            (ngModelChange)="settings.themePolicy.set($event)"
        >
            <div slot="label" class="wrapped" style="text-align: left; padding-right: 16px">Theme</div>
            <ion-select-option value="system">System Default</ion-select-option>
            <ion-select-option value="light">Light</ion-select-option>
            <ion-select-option value="dark">Dark</ion-select-option>
        </ion-select>
    </ion-item>

    @if (isUnitSelectionReady) {
        <ion-list-header>Units</ion-list-header>
        <unit-selector (userChange)="onUnitSelectionChange()"></unit-selector>
    }

    @if (updatesSupported) {
        <ion-list-header>Updates</ion-list-header>
        @if (updateCheckError) {
            <ion-item>
                <ion-label>
                    <div class="check-time">Checking for updates failed at {{ lastCheckTime }}</div>
                    <div class="ion-text-wrap">{{ updateCheckError }}</div>
                </ion-label>
                <ion-icon name="warning" color="warning" slot="end"></ion-icon>
            </ion-item>
        }
        @if (!lastCheckTime) {
            <ion-item>
                @if (updateCheckInProgress) {
                    <ion-label>Checking for updates now...</ion-label>
                } @else {
                    <ion-label>HGM Charts has not checked for updates yet.</ion-label>
                    <ion-button (click)="checkForUpdate()">Check now</ion-button>
                }
            </ion-item>
        }
        @if (lastSuccessfulCheckTime) {
            @if (updateAvailable) {
                <ion-item>
                    <ion-label>
                        <div class="check-time">Last checked: {{ lastSuccessfulCheckTime }}</div>
                        <div class="ion-text-wrap">A new version of HGM Charts is available.</div>
                    </ion-label>
                    <ion-button (click)="applyUpdate()">Restart</ion-button>
                </ion-item>
            } @else {
                <ion-item>
                    <ion-label>
                        <div class="check-time">Last checked: {{ lastSuccessfulCheckTime }}</div>
                        <div class="ion-text-wrap">HGM Charts is up to date.</div>
                    </ion-label>
                    <ion-button [disabled]="updateCheckInProgress" (click)="checkForUpdate()">Check now</ion-button>
                </ion-item>
            }
        }
    }
</ion-content>
